import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="page container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Episode 3: Military Service, Ahjummas, S.K.Y. — Q and A!</h1>
                        <h5 className="korean-title">특별 에피소드 3: 군대, 아줌마, 스카이 - 질문/답</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

                    Click <a target="_blank" href="https://docs.google.com/document/d/13GiV140kcQNl3RqVOoKsvSJxq0YWaIxbmiCaBr3380k/edit?usp=sharing">here</a> to check out the list of Korean songs.
                    <br></br>
                    <br></br>
                    S.K.Y. - 서울대학교 (seoul national university), 고려대학교 (korea university), 연세대학교 (yonsei university)
                    <br></br>
                    <br></br>
                    젓가락 - chopsticks
                    <br></br>
                    <br></br>
                    커플템 - couple items
                    <br></br>
                    100일 - 100 days (special day in a relationship)
                    <br></br>
                    화이트 데이 - white day (reverse valentine's day)
                    <br></br>
                    첫눈을 같이 맞으면 사랑이 이루어진다 - belief that if a couple gets snowed on together, their love will last
                    <br></br>
                    사랑의 자물쇠 - locks of love
                    <br></br>
                    아줌마 - married or middle aged woman
                    <br></br>
                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;